import {EPathname} from './dataEnum';

export const DISABLE_PAGE = [
  EPathname.CONSOLIDATION_REVIEW,
  EPathname.CONSOLIDATION_VIEW,
  EPathname.CONSOLIDATED_REVIEW,
  EPathname.MANAGE_EMPLOYEE,
  EPathname.TEAM_ASSIGNMENT,
  EPathname.MANAGE_PRACTICES,
  EPathname.MANAGE_DEPARTMENT_ROLE,
  EPathname.MANAGE_ROLE_LEVEL,
  EPathname.MANAGE_PERIODS,
  EPathname.MANAGE_PROJECT,
  EPathname.MESSAGE_INBOX_MANAGER,
  EPathname.MESSAGE_INBOX_USER,
  EPathname.USER_AUTHENTICATION,
  EPathname.MANAGE_OFFICE,
];
